/**
 * Fachmodule, die je Installation an- oder abgeschaltet sind.
 *
 * Canalis laeuft als eine Codebasis fuer mehrere Firmen. Welche Module
 * eine Installation nutzt, bestimmt die Umgebungsvariable CANALIS_MODULES.
 * Ein abgeschaltetes Modul existiert fuer die Installation nicht: Seine
 * Routen werden nicht registriert, seine Menuepunkte nicht angezeigt und
 * seine Rechte nicht vergeben.
 *
 * Das Datenbankschema kennt keine Module: Die Tabellen sind fuer alle
 * Installationen identisch und bei abgeschaltetem Modul schlicht leer.
 * Sonst liefen die Migrationen der Installationen auseinander.
 */
export const MODULES = [
    {
        key: 'crm',
        label: 'CRM',
        description: 'Kontakthistorie am Kunden und Wiedervorlagen mit Zuständigkeit',
    },
    {
        key: 'complaints',
        label: 'Reklamationen',
        description: 'Rückläufer und Beanstandungen zu Belegen erfassen und abwickeln',
    },
    {
        key: 'repairs',
        label: 'Reparaturen',
        description: 'Reparaturaufträge mit Material und Arbeitszeit bis zur Rechnung',
    },
    {
        key: 'rental',
        label: 'Mietpark',
        description: 'Mietgeräte mit Verfügbarkeit, Vermietung und laufender Abrechnung',
    },
];
export const MODULE_KEYS = MODULES.map((entry) => entry.key);
export const MODULE_LABELS = Object.fromEntries(MODULES.map((entry) => [entry.key, entry.label]));
export function isModuleKey(value) {
    return MODULE_KEYS.includes(value);
}
/**
 * Liest eine kommagetrennte Modulliste, etwa "complaints, rental".
 *
 * Unbekannte Eintraege werden nicht verworfen, sondern gemeldet: Ein
 * Tippfehler in der Konfiguration soll den Start abbrechen, nicht still
 * ein Modul abschalten, auf das sich jemand verlaesst.
 */
export function parseModuleList(raw) {
    const entries = (raw ?? '')
        .split(',')
        .map((entry) => entry.trim().toLowerCase())
        .filter((entry) => entry.length > 0);
    const modules = new Set();
    const unknown = [];
    for (const entry of entries) {
        if (isModuleKey(entry))
            modules.add(entry);
        else
            unknown.push(entry);
    }
    // Reihenfolge wie in MODULES, nicht wie in der Konfiguration - damit
    // Anzeigen daraus stabil sortiert sind.
    return { modules: MODULE_KEYS.filter((key) => modules.has(key)), unknown };
}
//# sourceMappingURL=modules.js.map